import { ENDPOINTS } from "Config/endpoints";
import protectedApi from "Config/protectedApi";

export const getSliderFn = () => {
    const response = protectedApi.get(`${ENDPOINTS.slider_api}`);
    return response;
}

export const getSliderByIdFn = (id) => {
    const response = protectedApi.get(`${ENDPOINTS.slider_api}?slider_id=${id}`);
    return response;
}

export const postSliderFn = (reqBody) => {
    const response = protectedApi.post(`${ENDPOINTS.slider_api}`, reqBody);
    return response;
}

export const patchSliderFn = (reqBody) => {
    const response = protectedApi.patch(`${ENDPOINTS.slider_api}`, reqBody);
    return response;
}

export const deleteSliderFn = (reqBody) => {
    const response = protectedApi.delete(`${ENDPOINTS.slider_api}`, { data: reqBody });
    return response;
}
